import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const OutfitDetailPage = lazy(
  () =>
    import('./OutfitDetailPage.eager').then(mod => ({
      default: mod.OutfitDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
